import React from 'react';
import { CircleInfoIcon, CalendarIcon, ClipboardIcon } from '@revfluence/fresh-icons/solid/esm';
import { Badge } from '@/shadcn/components/ui/badge';

interface ApplicationHeaderProps {
  applicationTitle: string;
  applicationDate?: string | null;
}

export const ApplicationHeader: React.FC<ApplicationHeaderProps> = ({
  applicationTitle,
  applicationDate,
}) => {
  const formatDate = (dateString: string | null | undefined) => {
    if (!dateString) return null;

    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
      });
    } catch {
      return null;
    }
  };

  const formattedDate = formatDate(applicationDate);

  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-2">
        <div className="w-6 h-6 p-1 bg-pink-500 rounded-lg flex items-center justify-center">
          <ClipboardIcon className="w-3 h-3 text-white" />
        </div>
        <div className="text-grey-6 text-sm font-medium">
          Application: {applicationTitle}
        </div>
        <CircleInfoIcon className="w-4 h-4 text-grey-4" />
      </div>

      {formattedDate && (
        <Badge
          variant="secondary"
          className="px-2 py-0.5 bg-grey-2 rounded-lg flex items-center gap-1"
        >
          <CalendarIcon className="w-3 h-3 text-grey-6" />
          <span className="text-grey-6 text-xs font-normal">
            {formattedDate}
          </span>
        </Badge>
      )}
    </div>
  );
};
